var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-option',_vm._g(_vm._b({},'el-option',_vm.$attrs,false),_vm.$listeners),[_vm._t("default",[_c('my-tooltip',{attrs:{"placement":"top","content":_vm.$attrs.label}},[_c('div',[_vm._v("\n        "+_vm._s(_vm.$attrs.label || '')+"\n      ")])])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75ffb3a2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MyOption.vue
// module id = null
// module chunks = 